import React, { useState, useEffect } from 'react';
import { 
  SafeAreaView, 
  StyleSheet, 
  View, 
  Text, 
  FlatList, 
  Image, 
  TouchableOpacity, 
  ActivityIndicator, 
  TextInput, 
  ScrollView, Linking
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';


import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import { LinearGradient } from 'expo-linear-gradient';
import { Platform, Button } from 'react-native';

import { useFocusEffect } from '@react-navigation/native';
import { useRef } from 'react';








const App = ({ navigation }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  

  const [userData, setUserData] = useState({});


  const [promoExpanded, setPromoExpanded] = useState(false);


const [followerFilter, setFollowerFilter] = useState(Infinity);
const [followerFilterVisible, setFollowerFilterVisible] = useState(false);


  // ✅ Scroll position refs
  const listRef = useRef(null);
  const scrollOffsetRef = useRef(0);

  // ✅ NEW: grid list ref + restore refs
  const gridListRef = useRef(null);
  const lastPageRef = useRef(1);
  const lastViewModeRef = useRef('list');

  // ✅ NEW: view mode toggle
  const [viewMode, setViewMode] = useState('list'); // 'list' | 'grid'
const GRID_COLUMNS = 2;


  const [page, setPage] = useState(1);
  const ITEMS_PER_PAGE = 30;

  // ✅ NEW: prevent onEndReached from spamming
  const endReachedLockRef = useRef(false);
  useEffect(() => {
    endReachedLockRef.current = false;
  }, [page, filteredData.length, loading, viewMode]);


  const [imageLoadedMap, setImageLoadedMap] = useState({});


  const FALLBACK_CARD =
  'https://images.pexels.com/photos/1058277/pexels-photo-1058277.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1';

const firstImageFromCsv = (value) => {
  if (!value || !String(value).trim()) return FALLBACK_CARD;

  const first = String(value)
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)[0];

  return first || FALLBACK_CARD;  // ✅ DB already stores full URLs
};


const parseFollowers = (str) => {
  if (!str) return 0;
  const s = str.toLowerCase().trim();

  if (s === "no min.") return 0;
  if (s.endsWith("k")) return parseFloat(s) * 1000;
  if (s.endsWith("m")) return parseFloat(s) * 1000000;

  return parseInt(s) || 0;
};

// =============================================
// Pre-release eligibility (button gate)
// =============================================
const PRE_RELEASE_TIERS = ["AAA","AA","A","BBB","BB","B","C"];

const canSeePreRelease = (user) => {
  const followers = parseFollowers(user?.PlatformFollowers);
  const rating = String(user?.CreatorRating || "").trim().toUpperCase();
  return followers > 10000 && PRE_RELEASE_TIERS.includes(rating);
};



// ✅ ADD THIS LINE HERE
const showPreReleaseButton = canSeePreRelease(userData);

// =============================================
// Early Access Eligibility Helpers
// =============================================
const EARLY_ACCESS_TIERS = ["AAA", "AA", "A"];

const hasEarlyAccess = (user) => {
  if (!user || !user.CreatorRating) return false;
  return EARLY_ACCESS_TIERS.includes(user.CreatorRating.trim().toUpperCase());
};

const getOfferAgeDays = (createdAt) => {
  if (!createdAt) return 999;
  const created = new Date(createdAt);
  const now = new Date();
  return (now - created) / (1000 * 60 * 60 * 24);
};



// --- search helper: matches BrandName OR OnBehalfOf ---
const matchesSearch = (item, query) => {
  const q = (query || '').toLowerCase();
  if (!q) return true;
  const brand = (item.BrandName || '').toLowerCase();
  const obo   = (item.OnBehalfOf || '').toLowerCase();
  return brand.includes(q) || obo.includes(q);
};



  const [sortOption, setSortOption] = useState(''); // Default no sorting
  const sortData = (data, option) => {
    if (!data || data.length === 0) return data;
  
    switch (option) {
      case 'a-z':
        return [...data].sort((a, b) => a.BrandName.localeCompare(b.BrandName));
      case 'price-low-high':
        return [...data].sort((a, b) => parseFloat(a.Credits) - parseFloat(b.Credits));
      case 'price-high-low':
        return [...data].sort((a, b) => parseFloat(b.Credits) - parseFloat(a.Credits));
      case 'newest':
        return [...data].sort((a, b) => new Date(b.Created_At) - new Date(a.Created_At));
      default:
        return data;
    }
  };
  
  
  const [sortVisible, setSortVisible] = useState(false);



  const [selectedCategory, setSelectedCategory] = useState('');
  const [categories, setCategories] = useState([]);

  // 🔥 Area filter state
const [areaFilterVisible, setAreaFilterVisible] = useState(false);
const [areaSearch, setAreaSearch] = useState('');


const [eligibleOnly, setEligibleOnly] = useState(false);
const [showEligiblePopup, setShowEligiblePopup] = useState(false);



const [selectedAreas, setSelectedAreas] = useState([]);


// 🔥 Area fallback helper (Area → Location)
const getDisplayArea = (item) => {
  if (item.Area && item.Area.trim() !== '') return item.Area.trim();
  return item.Location ? item.Location.trim() : '';
};


const uniqueAreas = React.useMemo(() => {
  return [...new Set(data.map(item => getDisplayArea(item)))]
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));   // 🔥 SORT A→Z
}, [data]);


useEffect(() => {
  setPage(1);
}, [searchQuery, sortOption, selectedCategory]);

 const fetchData = async () => {
  try {
    const response = await fetch('https://collabbay.com/APIControllers/GetBrandListings.php');
    const result = await response.json();
    setData(result);
    setFilteredData(result);

    // Get unique categories
    const uniqueCategories = [...new Set(result.map(item => item.OfferCategory))];
    setCategories(uniqueCategories);
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};


useEffect(() => {
  if (loading) return;

  let sortedData = sortData(data, sortOption);

  if (searchQuery) {
  sortedData = sortedData.filter(item => matchesSearch(item, searchQuery));
}


  if (selectedCategory) {
    sortedData = sortedData.filter(item => item.OfferCategory === selectedCategory);
  }

// ✅ Filter by Min Followers Required
if (followerFilter !== Infinity) {
  sortedData = sortedData.filter(item =>
    parseFollowers(item.MinFollowersRequired) <= followerFilter
  );
}


// NEW — Filter ONLY offers the user is eligible for by follower count
if (eligibleOnly && userData?.PlatformFollowers) {
  const myFollowers = parseFollowers(userData.PlatformFollowers);

  sortedData = sortedData.filter(item =>
    parseFollowers(item.MinFollowersRequired) <= myFollowers
  );
}


// 🔥 AREA FILTERING (multi-select)
if (selectedAreas.length > 0) {
  sortedData = sortedData.filter(item => 
    selectedAreas.includes(getDisplayArea(item))
  );
}

// 🔥 AREA SEARCH WITHIN DROPDOWN
if (areaSearch.trim() !== '') {
  sortedData = sortedData.filter(item =>
    getDisplayArea(item).toLowerCase().includes(areaSearch.toLowerCase())
  );
}


// =============================================
// EARLY ACCESS FILTER (restrict new offers)
// =============================================
if (userData && userData.CreatorRating) {
  const isEarly = hasEarlyAccess(userData);

  sortedData = sortedData.filter(item => {
    const ageDays = getOfferAgeDays(item.Created_At);

    // Anyone can see offers 2+ days old
    if (ageDays >= 2) return true;

    // Offers <2 days require A/AA/AAA
    return isEarly === true;
  });
}


  setFilteredData(sortedData);
   setPage(1); // ← ADD THIS LINE
}, [
  searchQuery,
  data,
  sortOption,
  selectedCategory,
  selectedAreas,
  areaSearch,
  loading,
  eligibleOnly,           
  userData               
]);



  const fetchUserData = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/GetSessionData.php');
      const result = await response.json();
      setUserData(result);
    } catch (error) {
      console.error('Error fetching user data: ', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserData();
  }, []);



  const logClick = (button) => {
  if (!userData?.Username) return;

  const payload = { button, username: userData.Username };

  try {
    fetch('https://collabbay.com/APIControllers/AnalyseUserActivity.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      keepalive: true,
      body: JSON.stringify(payload),
    }).catch(() => {});
  } catch (_) {}
};



const handleCardPress = (listingID) => {
  // ✅ NEW: Save page + view for perfect restore
  lastPageRef.current = page;
  lastViewModeRef.current = viewMode;

  // ✅ Save current scroll position BEFORE leaving
  if (gridListRef.current && viewMode === 'grid') {
    try {
      gridListRef.current.scrollToOffset({
        offset: scrollOffsetRef.current,
        animated: false,
      });
    } catch (_) {}
  }

  if (listRef.current) {
    listRef.current.scrollToOffset({
      offset: scrollOffsetRef.current,
      animated: false,
    });
  }

  navigation.navigate('CreateSubmissionPage', { ListingID: listingID });
};


  // --- Awareness Challenge link helper ---
const CHALLENGE_URL = 'https://collabbay.com/CollabbayRefferalProgramme'; // ← set your real URL


const openChallenge = () => {
  logClick('ReferralPromo');

  if (Platform.OS === 'web') {
    window.open(CHALLENGE_URL, '_blank');
  } else {
    Linking.openURL(CHALLENGE_URL);
  }
};


const openEligibility = () => {
  if (Platform.OS === 'web') {
    window.open('https://collabbay.com/CollabbayRefferalProgramme', '_blank');
  } else {
    Linking.openURL('https://collabbay.com/CollabbayRefferalProgramme');
  }
};


  const handleLogout = async () => {
    try {
      const response = await fetch('https://collabbay.com/APIControllers/EndSession.php');
      await response.json();
      setUserData({});
      // Reload the app after logout
      window.location.reload();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleEditProfile = () => {
    window.open('https://collabbay.com/UpdateProfile.html');
  };

  const handlePersonIconPress = () => {
    if (userData.Username) {
      navigation.navigate('UserRecapPage');
    } else {
      navigation.navigate('LogInPage');
    }
  };





  const handleBackPress = () => {
    navigation.goBack();
  };

const renderItem = ({ item }) => {
  // stop shimmer per-card when its image finishes loading
  const imageLoaded = imageLoadedMap[item.ListingID] || false;
  const handleImageLoad = () => {
    setImageLoadedMap(prev => ({ ...prev, [item.ListingID]: true }));
  };

  // ✅ compute the card image *inside* renderItem, using your CSV→first-image helper
  const cardImage = firstImageFromCsv(item.LogoImage);


return (
  <TouchableOpacity
    style={styles.newCard}
    onPress={() => handleCardPress(item.ListingID)}
    activeOpacity={0.9}
  >


{/* ✅ Real image (behind) */}
<Image
  source={{ uri: cardImage }}
  style={styles.newCardImage}
  resizeMode="cover"
  onLoad={handleImageLoad}
  onError={handleImageLoad}
/>

{/* ✅ Shimmer overlay (only visible while loading) */}
<ShimmerPlaceHolder
  LinearGradient={LinearGradient}
  style={styles.newCardImage}
  shimmerColors={['#e0e0e0', '#f3f3f3', '#e0e0e0']}
  duration={1100}
  shimmerStyle={{ borderRadius: 14 }}
  visible={!loading && imageLoaded}
/>

    {/* Fade overlay */}
    <LinearGradient
      colors={['transparent', 'rgba(0,0,0,0.65)']}
      style={styles.newCardOverlay}
    />

    {/* Category badge */}
    {!!item.OfferCategory && (
      <View style={styles.categoryBadge}>
        <Text style={styles.categoryBadgeText}>{item.OfferCategory}</Text>
      </View>
    )}

    {/* Required Coins Badge */}
    {!!item.RequiredPoints && parseInt(item.RequiredPoints) > 0 && (
      <View style={styles.pointsRequiredBadge}>
        <Text style={styles.pointsRequiredText}>🪙 {item.RequiredPoints} CƵ Required</Text>
      </View>
    )}

    {/* Bottom content */}
    <View style={styles.newCardBottom}>
      <Text style={styles.newCardTitle}>
        {item.OnBehalfOf && item.OnBehalfOf.trim() !== ''
          ? item.OnBehalfOf
          : item.BrandName}
      </Text>

<View style={styles.bottomRow}>
  {!!item.Credits && (
    <View style={styles.newCreditsBadge}>
      <Text style={styles.newCreditsText}>£{item.Credits} value</Text>
    </View>
  )}

  {!!item.NonCreditOffer && (
    <View style={styles.newOfferPill}>
      <Text
        numberOfLines={1}
        ellipsizeMode="tail"
        style={styles.newOfferPillText}
      >
        {item.NonCreditOffer}
      </Text>
    </View>
  )}
</View>


    </View>

    {parseFollowers(item.MinFollowersRequired) > 0 && (
  <View style={styles.followBadge}>
    <Ionicons name="person-outline" size={12} color="#fff" />
    <Text style={styles.followBadgeText}>
      {item.MinFollowersRequired}+ 
    </Text>
  </View>
)}


    {/* ✅ Location Footer Bar */}
{getDisplayArea(item) !== '' && (
  <View style={styles.locationBar}>
    <Ionicons name="location-outline" size={14} color="#fff" />
    <Text style={styles.locationBarText}>
      {getDisplayArea(item).length > 40 
        ? getDisplayArea(item).slice(0, 40) + '…'
        : getDisplayArea(item)
      }
    </Text>
  </View>
)}

  </TouchableOpacity>
);
};



// ✅ NEW: grid is a totally separate render (default cards unchanged)
const renderGridItem = ({ item }) => {
  const imageLoaded = imageLoadedMap[item.ListingID] || false;
  const handleImageLoad = () => {
    setImageLoadedMap(prev => ({ ...prev, [item.ListingID]: true }));
  };

  const cardImage = firstImageFromCsv(item.LogoImage);
  const displayName =
    item.OnBehalfOf && item.OnBehalfOf.trim() !== '' ? item.OnBehalfOf : item.BrandName;

  const area = getDisplayArea(item);
  const minFollowersNum = parseFollowers(item.MinFollowersRequired);

  return (
    <TouchableOpacity
      style={styles.gridCard}
      onPress={() => handleCardPress(item.ListingID)}
      activeOpacity={0.92}
    >
      <View style={styles.gridImageWrap}>
        <Image
          source={{ uri: cardImage }}
          style={styles.gridImage}
          resizeMode="cover"
          onLoad={handleImageLoad}
          onError={handleImageLoad}
        />

        <ShimmerPlaceHolder
          LinearGradient={LinearGradient}
          style={styles.gridImage}
          shimmerColors={['#e0e0e0', '#f3f3f3', '#e0e0e0']}
          duration={1100}
          shimmerStyle={{ borderRadius: 14 }}
          visible={!loading && imageLoaded}
        />

        {!!item.OfferCategory && (
          <View style={styles.gridCategoryPill}>
            <Text style={styles.gridCategoryText} numberOfLines={1}>
              {item.OfferCategory}
            </Text>
          </View>
        )}

        {!!item.RequiredPoints && parseInt(item.RequiredPoints) > 0 && (
          <View style={styles.gridPointsPill}>
            <Text style={styles.gridPointsText} numberOfLines={1}>
              🪙 {item.RequiredPoints}
            </Text>
          </View>
        )}

        {minFollowersNum > 0 && (
          <View style={styles.gridFollowersPill}>
            <Ionicons name="person-outline" size={12} color="#000" />
            <Text style={styles.gridFollowersText} numberOfLines={1}>
              {item.MinFollowersRequired}+
            </Text>
          </View>
        )}
      </View>

      <View style={styles.gridBody}>
        <Text style={styles.gridTitle} numberOfLines={2}>
          {displayName}
        </Text>

        {!!item.NonCreditOffer && (
          <Text style={styles.gridOfferText} numberOfLines={2}>
            {item.NonCreditOffer}
          </Text>
        )}

        <View style={styles.gridMetaRow}>
          {!!item.Credits && (
            <View style={styles.gridValuePill}>
              <Text style={styles.gridValueText} numberOfLines={1}>£{item.Credits}</Text>
            </View>
          )}

          {area !== '' && (
            <View style={styles.gridAreaRow}>
              <Ionicons name="location-outline" size={12} color="#000" />
              <Text style={styles.gridAreaText} numberOfLines={1}>
                {area}
              </Text>
            </View>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};


// ✅ NEW: auto-load more (dynamic every X items)
const handleEndReached = () => {
  if (loading) return;
  if (endReachedLockRef.current) return;
  if (page * ITEMS_PER_PAGE >= filteredData.length) return;

  endReachedLockRef.current = true;
  setPage(p => p + 1);
};


// ✅ NEW: toggle view + keep scroll position when swapping
const toggleViewMode = () => {
  const next = viewMode === 'list' ? 'grid' : 'list';
  setViewMode(next);
  lastViewModeRef.current = next;

  setTimeout(() => {
    const refToUse = next === 'grid' ? gridListRef : listRef;
    if (refToUse.current) {
      try {
        refToUse.current.scrollToOffset({
          offset: scrollOffsetRef.current || 0,
          animated: false,
        });
      } catch (_) {}
    }
  }, 120);
};



  // ✅ Restore scroll when returning to this page
  useFocusEffect(
    React.useCallback(() => {
      if (listRef.current) {
        setTimeout(() => {
          listRef.current.scrollToOffset({
            offset: scrollOffsetRef.current,
            animated: false,
          });
        }, 0);
      }
    }, [])
  );

  // ✅ NEW: restore page + view + scroll AFTER the list is actually there
  useFocusEffect(
    React.useCallback(() => {
      // restore view + page first (so list has enough items)
      setViewMode(lastViewModeRef.current || 'list');
      setPage(lastPageRef.current || 1);

      const t = setTimeout(() => {
        const useGrid = (lastViewModeRef.current || 'list') === 'grid';
        const refToUse = useGrid ? gridListRef : listRef;

        if (refToUse.current) {
          try {
            refToUse.current.scrollToOffset({
              offset: scrollOffsetRef.current || 0,
              animated: false,
            });
          } catch (_) {}
        }
      }, 220);

      return () => clearTimeout(t);
    }, [])
  );


  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
<SafeAreaView style={[styles.container, { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 }]}>

  
<View style={styles.contentContainer}>


<TouchableOpacity 
  style={styles.promoCard} 
  activeOpacity={0.9}
  onPress={() => setPromoExpanded(prev => !prev)}
>

  <LinearGradient
    colors={['rgba(253,240,93,0.25)', 'rgba(253,240,93,0)']}
    start={{ x: 0, y: 0 }}
    end={{ x: 1, y: 1 }}
    style={styles.promoHalo}
  />

  <View style={styles.paidPill}>
    <Text style={styles.paidPillText}>£100 • PAID</Text>
  </View>


  <Text style={styles.promoTitle}>✨ £100 Paid Refferals</Text>

  {promoExpanded && (
  <>
    <Text style={styles.promoSub}>
      Send your invite link to venues . That's it- earn £100 for subscribers. <Text style={{ fontWeight: '700' }}>£100</Text>.
    </Text>

    <View style={styles.promoBottomRow}>
    <TouchableOpacity 
  style={styles.eligibilityBtn}
  activeOpacity={0.7}
  onPress={(e) => {
    e.stopPropagation(); // ❗ prevents collapsing promo card
    openEligibility();
  }}
>
  <Text style={styles.eligibilityText}>Check eligibility</Text>
  <Ionicons name="chevron-forward" size={16} color="#0b0b0c" />
</TouchableOpacity>

      <Text style={styles.promoMeta}>Limited time</Text>
    </View>
  </>
)}


</TouchableOpacity>




<View style={styles.topButtonsRow}>

  {/* ✅ Pre-release (less prominent + NEW badge + arrow-right) */}
  {showPreReleaseButton && (
    <TouchableOpacity
      style={styles.preReleaseButton}
      onPress={() => navigation.navigate('PreReleaseListings')}
      activeOpacity={0.85}
    >
      <View style={styles.preReleaseNewBadge}>
        <Text style={styles.preReleaseNewText}>NEW</Text>
      </View>

      <Text style={styles.preReleaseButtonText}>Pre-release offers</Text>

      <Ionicons name="chevron-forward" size={16} color="#000" />
    </TouchableOpacity>
  )}

  {/* ✅ New Offers (on the RIGHT, less loud) */}
  <TouchableOpacity
    style={[
      styles.newOffersButton,
      sortOption === 'newest' && styles.newOffersButtonActive
    ]}
    onPress={() => setSortOption(prev => (prev === 'newest' ? '' : 'newest'))}
    activeOpacity={0.85}
  >
    <Text style={styles.newOffersButtonText}>✨ New Offers</Text>
  </TouchableOpacity>

</View>



      <View>

<View style={styles.filterRow}>

  {/* Area Filter Button */}
  <TouchableOpacity
    style={styles.areaFilterButton}
    onPress={() => setAreaFilterVisible(!areaFilterVisible)}
  >
    <Ionicons 
      name="map-outline" 
      size={14} 
      color="#000" 
      style={{ marginRight: 4, zIndex: 1 }} 
    />
    <Text style={styles.areaFilterText}>Area</Text>
  </TouchableOpacity>


{/* Followers Eligibility Toggle */}
<TouchableOpacity
  style={[
    styles.areaFilterButton,
    eligibleOnly && { backgroundColor: '#fdf05d', borderColor: '#000' }
  ]}
  onPress={() => {
    if (eligibleOnly) {
      // If already active → close it immediately when X is tapped
      setEligibleOnly(false);
    } else {
      // Otherwise → open popup
      setShowEligiblePopup(true);
    }
  }}
>
  <Ionicons 
    name="person-outline" 
    size={14} 
    color="#000" 
    style={{ marginRight: 4 }}
  />
  <Text style={styles.areaFilterText}>Followers</Text>

  {eligibleOnly && (
    <Ionicons
      name="close-circle"
      size={14}
      color="#000"
      style={{ marginLeft: 4 }}
    />
  )}
</TouchableOpacity>


  {/* ✅ NEW GRID TOGGLE (separate render) */}
  <TouchableOpacity style={styles.viewToggleBtn} onPress={toggleViewMode}>
    <Ionicons
      name={viewMode === 'grid' ? 'list-outline' : 'grid-outline'}
      size={22}
      color="black"
    />
    {viewMode === 'list' && (
      <View style={styles.viewToggleNewBadge}>
        <Text style={styles.viewToggleNewText}>NEW</Text>
      </View>
    )}
  </TouchableOpacity>


  {/* Sort Icon */}
  <TouchableOpacity style={styles.sortIcon} onPress={() => setSortVisible(!sortVisible)}>
    <Ionicons name="filter-outline" size={24} color="black" />
  </TouchableOpacity>

</View>


  {/* Existing Sort Buttons, Hidden Until Clicked */}
  {sortVisible && (
  <View style={styles.sortContainer}>
    <TouchableOpacity style={styles.sortButton} onPress={() => { setSortOption('a-z'); setSortVisible(false); }}>
      <Text style={styles.sortText}>A-Z</Text>
    </TouchableOpacity>
    <TouchableOpacity style={styles.sortButton} onPress={() => { setSortOption('price-low-high'); setSortVisible(false); }}>
      <Text style={styles.sortText}>Value Low-High</Text>
    </TouchableOpacity>
    <TouchableOpacity style={styles.sortButton} onPress={() => { setSortOption('price-high-low'); setSortVisible(false); }}>
      <Text style={styles.sortText}>Value High-Low</Text>
    </TouchableOpacity>
    <TouchableOpacity style={styles.sortButton} onPress={() => { setSortOption('newest'); setSortVisible(false); }}>
      <Text style={styles.sortText}>Newest</Text>
    </TouchableOpacity>
  </View>
)}


  

</View>



        <TouchableOpacity style={styles.backButton} onPress={handleBackPress}>
          <Ionicons name="arrow-back" size={28} color="black" />
        </TouchableOpacity>
        <TextInput
          style={styles.searchBar}
          placeholder="Search..."
          value={searchQuery}
          onChangeText={setSearchQuery}
          maxLength={500}
        />




{/* FOLLOWERS POPUP */}
{showEligiblePopup && (
  <View style={styles.popupOverlay}>
    <View style={styles.popupBox}>


<Text style={styles.popupTitle}>
  Only show me offers that I meet the required minimum follower-count for?
</Text>


      <View style={styles.popupButtonsRow}>
        <TouchableOpacity
          style={styles.popupApply}
          onPress={() => {
            setEligibleOnly(true);
            setShowEligiblePopup(false);
          }}
        >
          <Text style={styles.popupApplyText}>Apply</Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={styles.popupCancel}
          onPress={() => setShowEligiblePopup(false)}
        >
          <Text style={styles.popupCancelText}>Cancel</Text>
        </TouchableOpacity>
      </View>
    </View>
  </View>
)}


        {/* AREA DROPDOWN (EXPANDED) */}
{areaFilterVisible && (
  <View style={styles.areaDropdown}>

<TouchableOpacity
  style={styles.areaCloseX}
  onPress={() => setAreaFilterVisible(false)}
>
  <Ionicons name="close" size={20} color="#000" />
</TouchableOpacity>

    {/* Search input INSIDE dropdown */}
    <TextInput
      style={styles.areaSearchInput}
      placeholder=""
      value={areaSearch}
      onChangeText={setAreaSearch}
    />

    {/* Area list */}
    <ScrollView style={{ maxHeight: 200 }}>
      {uniqueAreas
        .filter(area =>
          area.toLowerCase().includes(areaSearch.toLowerCase())
        )
        .map((area, index) => (
          <TouchableOpacity
            key={index}
            style={[
              styles.areaPill,
              selectedAreas.includes(area) && styles.areaPillSelected
            ]}
            onPress={() => {
              setSelectedAreas(prev =>
                prev.includes(area)
                  ? prev.filter(a => a !== area)
                  : [...prev, area]
              );
            }}
          >
            <Text style={styles.areaPillText}>{area}</Text>
          </TouchableOpacity>
        ))}
    </ScrollView>

    {/* Apply / Close button */}
    <TouchableOpacity
      style={styles.applyAreaButton}
      onPress={() => setAreaFilterVisible(false)}
    >
      <Text style={styles.applyAreaButtonText}>Apply</Text>
    </TouchableOpacity>

  </View>
)}


        {selectedAreas.length > 0 && (
  <ScrollView 
    horizontal 
    showsHorizontalScrollIndicator={false}
    style={{ marginBottom: 8, marginTop: 4 }}
  >
    {selectedAreas.map((area, index) => (
      <View key={index} style={styles.selectedAreaChip}>
        <Text style={styles.selectedAreaChipText}>{area}</Text>
        <TouchableOpacity
          onPress={() =>
            setSelectedAreas(prev => prev.filter(a => a !== area))
          }
        >
          <Ionicons
            name="close-circle"
            size={16}
            color="#000"
            style={{ marginLeft: 4 }}
          />
        </TouchableOpacity>
      </View>
    ))}
  </ScrollView>
)}


<ScrollView 
  horizontal 
  showsHorizontalScrollIndicator={false} 
  style={{ marginBottom: 10 }}
>
  <TouchableOpacity 
    style={[
      styles.categoryButton, 
      selectedCategory === '' && styles.selectedCategoryButton
    ]}
    onPress={() => setSelectedCategory('')}
  >
    <Ionicons name="grid-outline" size={16} color="#000" />
    <Text style={styles.categoryText}>All</Text>
  </TouchableOpacity>

 {categories
  .filter(Boolean) // ← removes empty strings, null, undefined
  .map((category, index) => (
    <TouchableOpacity 
      key={index}
      style={[
        styles.categoryButton,
        selectedCategory === category && styles.selectedCategoryButton
      ]}
      onPress={() => setSelectedCategory(category)}
    >
      <Ionicons name="pricetags-outline" size={16} color="#000" />
      <Text style={styles.categoryText}>{category}</Text>
    </TouchableOpacity>
  ))}
</ScrollView>


{/* ✅ NEW: quick “sections” only for GRID mode (periodic / dynamic feel) */}
{viewMode === 'grid' && (
  <ScrollView
    horizontal
    showsHorizontalScrollIndicator={false}
    contentContainerStyle={styles.gridSectionsRow}
    style={{ marginBottom: 8 }}
  >
    <TouchableOpacity style={styles.sectionChip} onPress={() => setSortOption('')}>
      <Text style={styles.sectionChipText}>All</Text>
    </TouchableOpacity>
    <TouchableOpacity style={styles.sectionChip} onPress={() => setSortOption('newest')}>
      <Text style={styles.sectionChipText}>✨ New</Text>
    </TouchableOpacity>

  </ScrollView>
)}



        {loading ? (
          <ActivityIndicator size="large" color="#000" />
        ) : (
          viewMode === 'list' ? (
<FlatList
  ref={listRef}

  onScroll={e => {
    scrollOffsetRef.current = e.nativeEvent.contentOffset.y;
  }}
  scrollEventThrottle={16}

  data={filteredData.slice(0, page * ITEMS_PER_PAGE)}
  renderItem={renderItem}
  keyExtractor={(item) => item.ListingID.toString()}
  contentContainerStyle={styles.list}

  // ✅ NEW: dynamic load-more every X items
  onEndReachedThreshold={0.35}
  onEndReached={handleEndReached}
/>
          ) : (
<FlatList
  key={`grid-${GRID_COLUMNS}`}
  ref={gridListRef}
  numColumns={GRID_COLUMNS}

  onScroll={e => {
    scrollOffsetRef.current = e.nativeEvent.contentOffset.y;
  }}
  scrollEventThrottle={16}

  data={filteredData.slice(0, page * ITEMS_PER_PAGE)}
  renderItem={renderGridItem}
  keyExtractor={(item) => item.ListingID.toString()}
  contentContainerStyle={[styles.list, styles.gridList]}
  columnWrapperStyle={styles.gridRow}

  // ✅ NEW: dynamic load-more every X items
  onEndReachedThreshold={0.35}
  onEndReached={handleEndReached}
/>
          )
        )}

        {!loading && (
  <TouchableOpacity
    onPress={() => {
      if (page * ITEMS_PER_PAGE < filteredData.length) {
        setPage(p => p + 1);
      }
    }}
    style={[
      styles.loadMoreButton,
      (page * ITEMS_PER_PAGE >= filteredData.length) && { opacity: 0.5 }
    ]}
    disabled={page * ITEMS_PER_PAGE >= filteredData.length}
  >
    <Text style={styles.loadMoreText}>
      {page * ITEMS_PER_PAGE < filteredData.length ? 'Show more' : 'No more results'}
    </Text>
  </TouchableOpacity>
)}




<Text style={styles.customiseCTA}>Prepare your profile to be able to apply to collabs.</Text>

<Text style={styles.customiseCTAsub}>Edit your profile to add a bio, your content categories, and a profile image. Your profile is seen by brands when you book their venues.</Text>


      </View>
      <View style={styles.footer}>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('Homepage')}>
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>

        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CollabCalendar')}>
          <Ionicons name="calendar" size={24} color="black" />
        </TouchableOpacity>






  {userData.Username ? (
<TouchableOpacity
  onPress={() => navigation.navigate('MyFeed')}
  style={{
    backgroundColor: "#fdf05d",
    padding: 10,
    borderRadius: 20,
  }}
>
  <Ionicons name="film-outline" size={22} color="black" />
</TouchableOpacity>
) : (
<TouchableOpacity
 onPress={() => (window.location.href = 'https://collabbay.com/SignIn')}
  style={{
    backgroundColor: "#fdf05d",
    padding: 10,
    borderRadius: 20,
  }}
>
  <Ionicons name="film-outline" size={22} color="black" />
</TouchableOpacity>
)}

        <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('UserActivityFeed')}
  >
    <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />
  </TouchableOpacity>

        {userData.Username ? (
          <TouchableOpacity style={styles.footerIcon} onPress={handlePersonIconPress}>
            <Ionicons name="person" size={24} color="black" />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('LogInPage')}>
            <Ionicons name="person" size={24} color="black" />
          </TouchableOpacity>
        )}
      </View>
    </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    paddingHorizontal: 20,
    paddingTop: 70, // Added padding to account for the back button height
  },
  searchBar: {
    height: 40,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#ccc',
    paddingHorizontal: 15,
    marginVertical: 7,
    backgroundColor: '#f9f9f9',
    fontSize: 16,
  },
  list: {
    paddingBottom: 80, // Added padding for footer visibility
  },

  // ✅ NEW: grid layout helpers
  gridList: {
    paddingBottom: 80,
  },
  gridRow: {
    justifyContent: 'space-between',
  },

  card: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 15,
    marginVertical: 10,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 5,
  },
  logoImage: {
    width: '100%',
    height: 120,
    borderRadius: 10,
    marginBottom: 10,
    resizeMode: 'cover',
    backgroundColor: '#000',
  },
  cardContent: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  brandName: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
  },
  customiseCTA: {
    fontSize: 24,
    marginTop: '5',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
    textalign: 'center',
  },
pageTitle: {
    fontSize: 35,
    marginTop: '75',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
    textalign: 'center',
  },
  customiseCTAsub: {
    fontSize: 15,
    marginTop: '10',
    color: '#b2b2b2',
    marginBottom: 5,
    textalign: 'center',
  },
  description: {
    fontSize: 16,
    color: '#000',
    marginBottom: 10,
  },
  creditsContainer: {
    backgroundColor: '#EEEDEB',
    borderRadius: 20,
    padding: 5,
    marginBottom: 10,
  marginLeft: 20,
  },
  creditsPriceContainer: {
    backgroundColor: '#EEEDEB',
    borderRadius: 20,
    padding: 5,
    marginBottom: 10,
  },
  credits: {
    fontSize: 17,
    color: '#000',
    fontWeight: 'bold',
    padding: 5,
  },
  locationContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  locationText: {
    fontSize: 14,
    color: '#000',
    marginLeft: 10,
    
  },
    offerNonText: {
    fontSize: 14,
    color: '#000',
   
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    position: 'sticky',
    bottom: 0,
    backgroundColor: 'white',
    left: 0,
    right: 0,
    paddingVertical: 10,
  },
  footerIcon: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    position: 'absolute',
    top: 20,
    left: 20,
    zIndex: 1,
  },
  sortContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap', // ✅ allows multiple rows if buttons overflow horizontally
    justifyContent: 'center',
    marginBottom: 10,
    paddingHorizontal: 10,
  },  
  sortButton: {
    backgroundColor: '#EEEDEB',
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 10,
    margin: 5,
    maxWidth: '45%', // ✅ keeps buttons within half the width to prevent overflow
  },
  sortText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#000',
    textAlign: 'center', // ✅ centers text
    flexWrap: 'wrap',    // ✅ allows multiline
  },  
sortIcon: {
  alignSelf: 'flex-end',
  padding: 10,
},

// ✅ NEW: grid toggle button + NEW badge
viewToggleBtn: {
  alignSelf: 'flex-end',
  padding: 10,
  position: 'relative',
},
viewToggleNewBadge: {
  position: 'absolute',
  top: 6,
  right: 6,
  backgroundColor: '#fdf05d',
  borderRadius: 8,
  paddingHorizontal: 5,
  paddingVertical: 2,
  borderWidth: 1,
  borderColor: '#000',
},
viewToggleNewText: {
  fontSize: 8,
  fontWeight: '900',
  color: '#000',
  letterSpacing: 0.3,
},

categoryButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#EEEDEB',
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 20,
  marginRight: 10,
  borderWidth: 1,
  borderColor: '#ccc',
},
selectedCategoryButton: {
  backgroundColor: '#fdf05d', // Yellow highlight for selected
  borderColor: '#fdf05d',
},
categoryText: {
  marginLeft: 5,
  fontSize: 14,
  color: '#000',
  fontWeight: 'bold',
},
categoryBadge: {
  position: 'absolute',
  top: 19,
  right: 19,
  backgroundColor: '#f3f3f3',
  paddingVertical: 4,
  paddingHorizontal: 8,
  borderRadius: 12,
},
categoryBadgeText: {
  color: 'black',
  fontSize: 12,
  fontWeight: 'bold',
},
logoImage: {
  width: '100%',
  height: 120,
  borderRadius: 10,
  marginBottom: 10,
  resizeMode: 'cover',
  backgroundColor: '#f3f3f3', // Soft shimmer base
},
loadMoreButton: {
  marginTop: 0,
  alignSelf: 'center',
  backgroundColor: '#f3f3f3',
  paddingVertical: 10,
  marginBottom: 55,
  paddingHorizontal: 20,
  borderRadius: 20,
},
loadMoreText: {
  color: '#000',
  fontSize: 19,
  fontWeight: '600',
  textTransform: 'none',
},
floatingNewButton: {
  alignSelf: 'flex-end',           // Float right
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: 10,
  paddingVertical: 6,
  borderRadius: 20,
  overflow: 'hidden',
  minWidth: 0,
  minHeight: 0,
  position: 'relative',
  marginBottom: 6,
},
floatingNewButtonActive: {
  shadowColor: '#fdf05d',
  shadowOffset: { width: 0, height: 0 },
  shadowOpacity: 0.8,
  shadowRadius: 12,
  borderWidth: 2,
  borderColor: '#000',
  elevation: 5,
},

floatingNewBackground: {
  ...StyleSheet.absoluteFillObject,
  borderRadius: 20,
  opacity: 0.9,
},


areaFilterButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#EEEDEB',   // MATCH CATEGORY BUTTON
  paddingVertical: 8,
  paddingHorizontal: 14,
  borderRadius: 20,
  marginRight: 10,
  borderWidth: 1,
  borderColor: '#ccc',
  position: 'relative',
  overflow: 'visible',
},


areaFilterText: {
  fontWeight: '800',
  fontSize: 12,
  color: '#000',
  zIndex: 1,
},

areaDropdown: {
  backgroundColor: '#fff',
  padding: 10,
  borderRadius: 14,
  marginBottom: 10,
  borderWidth: 1,
  borderColor: '#ccc',
},

areaSearchInput: {
  height: 36,
  borderRadius: 10,
  backgroundColor: 'white',
  paddingHorizontal: 10,
  marginBottom: 8,
  fontSize: 14,
},

areaPill: {
  backgroundColor: '#EEEDEB',
  paddingVertical: 6,
  paddingHorizontal: 12,
  borderRadius: 14,
  marginBottom: 6,
},
areaPillSelected: {
  backgroundColor: '#fdf05d',
},
areaPillText: {
  fontSize: 14,
  fontWeight: '600',
  color: '#000',
},

floatingNewText: {
  fontWeight: 'bold',
  color: '#000',
  fontSize: 12,
  zIndex: 1,
  padding: 2,
},
promoCard: {
  position: 'relative',
  backgroundColor: 'rgba(16,16,20,0.85)',
  borderRadius: 23,
  padding: 16,
  marginBottom: 14,
  overflow: 'hidden',
  borderColor: 'rgba(255,255,255,0.06)',
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 8 },
  shadowOpacity: 0.2,
  shadowRadius: 20,
  elevation: 6,
},
promoHalo: {
  ...StyleSheet.absoluteFillObject,
},
paidPill: {
  position: 'absolute',
  top: 12,
  right: 12,
  backgroundColor: '#FDF05D',
  borderRadius: 999,
  paddingVertical: 4,
  paddingHorizontal: 10,
  borderWidth: 1,
  borderColor: '#0b0b0c',
},
paidPillText: {
  fontSize: 8,
  fontWeight: '800',
  letterSpacing: 0.4,
  color: '#0b0b0c',
},
pointsEarnedText: {
  fontSize: 13,
  color: '#000',
  fontWeight: '500',
  marginTop: -5,
  marginBottom: 6,
  backgroundColor: '#f3f3f3',   // ← light grey (secondary)
  alignSelf: 'flex-start',
  paddingVertical: 3,
  paddingHorizontal: 8,
  borderTopLeftRadius: 10,
  borderBottomRightRadius: 10,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: 0,
  overflow: 'hidden'
},

pointsRequiredBadge: {
  position: 'absolute',
  top: 15,
  left: 15,
  backgroundColor: '#fdf05d',
  paddingVertical: 4,
  paddingHorizontal: 8,
  zIndex: 5,
  borderTopLeftRadius: 10,   // 👈 only this corner
  borderBottomRightRadius: 12, // 👈 and this corner
  borderTopRightRadius: 0,   // leave others at 0 (or omit)
  borderBottomLeftRadius: 0
},
pointsRequiredText: {
  color: 'black',
  fontSize: 12,
  fontWeight: 'bold',
},

promoTitle: {
  fontSize: 18,
  fontWeight: '800',
  color: '#fff',
  marginTop: 6,
  marginBottom: 6,
},
promoSub: {
  fontSize: 14,
  color: '#d6d6d6',
  lineHeight: 20,
  marginBottom: 14,
},
promoBottomRow: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
},
eligibilityBtn: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#FDF05D',
  paddingVertical: 8,
  paddingHorizontal: 14,
  borderRadius: 14,
},
eligibilityText: {
  fontSize: 14,
  fontWeight: '800',
  color: '#0b0b0c',
  marginRight: 4,
},
promoMeta: {
  fontSize: 12,
  color: '#bdbdbd',
},


newCard: {
  height: 210,
  borderRadius: 14,
  marginVertical: 12,
  backgroundColor: '#000',
  overflow: 'hidden',
  position: 'relative',
},

newCardImage: {
  width: '100%',
  height: '100%',
  borderRadius: 14,
  backgroundColor: '#f3f3f3',
},

newCardOverlay: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 110,
  borderBottomLeftRadius: 14,
  borderBottomRightRadius: 14,
  zIndex: 0,            // ✅ sits behind all text + badges
},


newCardBottom: {
  position: 'absolute',
  bottom: 40,
  left: 12,
  right: 12,
  zIndex: 2,
  flexDirection: 'column',
},

newCardTitle: {
  color: '#fff',
  fontSize: 18,
  fontWeight: '800',
  marginBottom: 6,

  // ✅ subtle shadow for readability
  textShadowColor: 'rgba(0, 0, 0, 0.85)',
  textShadowOffset: { width: 0, height: 1 },
  textShadowRadius: 3,
},


newCreditsBadge: {
  alignSelf: 'flex-start',
  backgroundColor: 'rgba(253, 240, 93, 0.92)',  // ✅ slight transparency
  paddingVertical: 4,
  paddingHorizontal: 10,
  borderRadius: 10,
  marginBottom: 6,
},


newCreditsText: {
  color: '#000',
  fontWeight: '700',
  fontSize: 13,   // smaller
},


newOfferPill: {
  backgroundColor: 'rgba(0,0,0,0.40)',   // ✅ slightly darker
  paddingVertical: 4,
  paddingHorizontal: 10,
  borderRadius: 10,
  maxWidth: '70%',     // ✅ prevents overflow
},

newOfferPillText: {
  color: '#fff',
  fontSize: 13,        // ✅ slightly smaller
  fontWeight: '600',
},
followBadge: {
  position: 'absolute',
  top: 15,        // ✅ moved UP
  left: 15,       // ✅ moved LEFT
  backgroundColor: 'rgba(0,0,0,0.55)',
  flexDirection: 'row',
  alignItems: 'center',
  paddingVertical: 3,
  paddingHorizontal: 6,
  borderRadius: 8,
  zIndex: 10,
},

followBadgeText: {
  color: '#fff',
  fontSize: 10,
  fontWeight: '600',
  marginLeft: 3,
},

filterIcon: {
  alignSelf: 'flex-end',
  marginRight: 5,
  marginBottom: 8,
},

filterContainer: {
  backgroundColor: '#fff',
  padding: 8,
  borderRadius: 10,
  marginBottom: 10,
  shadowColor: '#000',
  shadowOpacity: 0.15,
  shadowRadius: 8,
  elevation: 5,
},

filterOption: {
  paddingVertical: 6,
  paddingHorizontal: 8,
},

filterText: {
  fontSize: 14,
  color: '#000',
  fontWeight: '600',
},
locationBar: {
  backgroundColor: 'rgba(0,0,0,0.45)',   // ✅ slightly lighter
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 32,
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: 10,
},
newAreaTag: {
  position: 'absolute',
  top: -8,
  right: -8,
  backgroundColor: 'black',
  paddingHorizontal: 6,
  paddingVertical: 2,
  borderRadius: 9,
  zIndex: 10,
  borderWidth: 1,
},

newAreaTagText: {
  fontSize: 8,
  fontWeight: '900',
  color: '#fdf05d',
},


locationBarText: {
  color: '#fff',
  fontSize: 10,
  fontWeight: '600',
},
bottomRow: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 8,
  marginTop: 2,
  maxWidth: '95%',
}, 
filterRow: {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: 4,
},

newBadge: {
  position: 'absolute',
  top: -6,
  left: -6,
  backgroundColor: '#fdf05d',
  paddingHorizontal: 6,
  paddingVertical: 2,
  borderRadius: 6,
  zIndex: 10,
},

newBadgeText: {
  fontSize: 8,
  fontWeight: '900',
  color: '#000',
},

selectedAreaChip: {
  flexDirection: 'row',
  backgroundColor: '#fdf05d',
  paddingVertical: 6,
  paddingHorizontal: 10,
  borderRadius: 20,
  alignItems: 'center',
  marginRight: 6,
},

selectedAreaChipText: {
  fontSize: 12,
  fontWeight: '700',
  color: '#000',
},

applyAreaButton: {
  backgroundColor: '#fdf05d',
  paddingVertical: 10,
  borderRadius: 10,
  alignItems: 'center',
  marginTop: 10,
},

applyAreaButtonText: {
  color: '#000',
  fontWeight: '800',
  fontSize: 14,
},
areaCloseX: {
  position: 'absolute',
  top: 9,
  right: 6,
  zIndex: 20,
  padding: 4,
},
popupOverlay: {
  position: 'fixed',     // <— change to fixed so it ignores parent padding
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.55)',
  justifyContent: 'center',
  alignItems: 'center',
  paddingHorizontal: 20, // matches area modal spacing
  zIndex: 999,
},


popupBox: {
  width: '100%',          // full width like area modal
  maxWidth: 320,          // similar to area modal feel
  backgroundColor: '#fff',
  padding: 18,
  borderRadius: 14,
  borderWidth: 1,
  borderColor: '#ccc',    // matches area modal border
  shadowColor: '#000',
  shadowOpacity: 0.15,
  shadowRadius: 10,
  elevation: 6,
},


popupTitle: {
  fontSize: 16,
  fontWeight: '700',
  color: '#000',
  textAlign: 'center',
  marginBottom: 20,
},

popupButtonsRow: {
  flexDirection: 'row',
  justifyContent: 'space-between',
},

popupApply: {
  flex: 1,
  backgroundColor: '#fdf05d',
  paddingVertical: 10,
  borderRadius: 10,
  marginRight: 6,
  alignItems: 'center',
},

popupApplyText: {
  fontSize: 14,
  fontWeight: '700',
  color: '#000',
},

popupCancel: {
  flex: 1,
  backgroundColor: '#f3f3f3',
  paddingVertical: 10,
  borderRadius: 10,
  marginLeft: 6,
  alignItems: 'center',
},

popupCancelText: {
  fontSize: 14,
  fontWeight: '700',
  color: '#000',
},

// ✅ NEW: grid “section chips”
gridSectionsRow: {
  gap: 8,
  paddingRight: 6,
},
sectionChip: {
  backgroundColor: '#EEEDEB',
  borderWidth: 1,
  borderColor: '#ccc',
  paddingHorizontal: 12,
  paddingVertical: 8,
  borderRadius: 999,
  marginRight: 8,
},
sectionChipText: {
  fontSize: 12,
  fontWeight: '800',
  color: '#000',
},

// ✅ NEW: grid card styles (separate from default list cards)
gridCard: {
  flex: 1,
  backgroundColor: '#fff',
  borderRadius: 14,
  borderWidth: 1,
  borderColor: '#eee',
  overflow: 'hidden',
  marginBottom: 12,
  marginHorizontal: 6,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 4 },
  shadowOpacity: 0.08,
  shadowRadius: 10,
  elevation: 2,
},
gridImageWrap: {
  position: 'relative',
  width: '100%',
  height: 120,
  backgroundColor: '#f3f3f3',
},
gridImage: {
  width: '100%',
  height: '100%',
  borderTopLeftRadius: 14,
  borderTopRightRadius: 14,
},
gridCategoryPill: {
  position: 'absolute',
  top: 8,
  right: 8,
  backgroundColor: '#f3f3f3',
  paddingHorizontal: 8,
  paddingVertical: 4,
  borderRadius: 12,
},
gridCategoryText: {
  fontSize: 10,
  fontWeight: '900',
  color: '#000',
},
gridPointsPill: {
  position: 'absolute',
  top: 8,
  left: 8,
  backgroundColor: '#fdf05d',
  paddingHorizontal: 8,
  paddingVertical: 4,
  borderRadius: 12,
  borderWidth: 1,
  borderColor: '#000',
},
gridPointsText: {
  fontSize: 10,
  fontWeight: '900',
  color: '#000',
},
gridFollowersPill: {
  position: 'absolute',
  bottom: 8,
  left: 8,
  backgroundColor: 'rgba(253,240,93,0.92)',
  paddingHorizontal: 8,
  paddingVertical: 4,
  borderRadius: 12,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  borderWidth: 1,
  borderColor: '#000',
},
gridFollowersText: {
  fontSize: 10,
  fontWeight: '900',
  color: '#000',
},
gridBody: {
  padding: 10,
},
gridTitle: {
  fontSize: 14,
  fontWeight: '900',
  color: '#000',
  lineHeight: 18,
},
gridOfferText: {
  marginTop: 6,
  fontSize: 12,
  color: '#333',
  lineHeight: 16,
},
gridMetaRow: {
  marginTop: 8,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
},
gridValuePill: {
  backgroundColor: '#fdf05d',
  borderRadius: 10,
  paddingHorizontal: 10,
  paddingVertical: 6,
  borderWidth: 1,
  borderColor: '#000',
},
gridValueText: {
  fontSize: 12,
  fontWeight: '900',
  color: '#000',
},
gridAreaRow: {
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
  justifyContent: 'flex-end',
},
gridAreaText: {
  fontSize: 11,
  fontWeight: '700',
  color: '#000',
  maxWidth: 120,
},
preReleaseButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 999,
  borderWidth: 1,
  borderColor: '#ddd',
},

preReleaseButtonText: {
  marginLeft: 6,
  fontSize: 12,
  fontWeight: '800',
  color: '#000',
},
topButtonsRow: {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 10,
  marginBottom: 6,
},

// ✅ New Offers (less prominent, right side)
newOffersButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 999,
  borderWidth: 1,
  borderColor: '#ddd',
},
newOffersButtonActive: {
  backgroundColor: '#fdf05d',
  borderColor: '#000',
},
newOffersButtonText: {
  fontSize: 12,
  fontWeight: '800',
  color: '#000',
},

// ✅ Pre-release (same NEW badge as grid toggle)
preReleaseButton: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: '#fff',
  paddingVertical: 8,
  paddingHorizontal: 12,
  borderRadius: 999,
  borderWidth: 1,
  borderColor: '#ddd',
  position: 'relative',
},
preReleaseButtonText: {
  fontSize: 12,
  fontWeight: '800',
  color: '#000',
  marginRight: 6,
},

preReleaseNewBadge: {
  position: 'absolute',
  top: -6,
  right: -6,
  backgroundColor: '#fdf05d',
  borderRadius: 8,
  paddingHorizontal: 5,
  paddingVertical: 2,
  borderWidth: 1,
  borderColor: '#000',
},
preReleaseNewText: {
  fontSize: 8,
  fontWeight: '900',
  color: '#000',
  letterSpacing: 0.3,
},


});

export default App;
